import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import TiktokCollectionsTracker from '../../../Modules/TikTok/audios/features/TiktokAudioCollections/TiktokCollectionsTracker/TiktokCollectionsTracker';
import { AudioPlayerProvider } from '../../../Modules/AudioPlayer/AudioPlayerContext';
import { CollectionsContextProvider } from '../../../Modules/TikTok/audios/features/TiktokAudioCollections/contexts/CollectionsContext';

const TiktokCollectionsPage = () => (
    <>
        <NavBar />
        <CollectionsContextProvider>
            <AudioPlayerProvider>
                <TiktokCollectionsTracker />
            </AudioPlayerProvider>
        </CollectionsContextProvider>
    </>
);

export default TiktokCollectionsPage;
